export function isSemVerOp(op: string): op is `semVer${string}` {
  return op.startsWith('semVer');
}
